module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_6.f2cdf2e7.png";